import { onSignalREvent } from '../../signalRBus'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import type { NewMessageSignalRPayload } from 'src/signalR/types'
import { useMessagingServiceStore } from 'src/stores/messaging.service.store'

onSignalREvent(
  SIGNAL_R_SCOPES.message,
  SIGNAL_R_MESSAGES.newMessage,
  (text, response) => {
    const payload: NewMessageSignalRPayload = JSON.parse(text)
    const messagingServiceStore = useMessagingServiceStore()
    messagingServiceStore.handleNewMessageEvent(
      payload,
      response.OrgId,
      response.CenterId,
    )
  },
)
